module.exports = "/Muli-Bold.020af55b8da945f6948b078554fa05c7.woff";